var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloppyDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.5 -1.5 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "floppy-disk--disk-floppy-electronics-device-disc-computer-storage"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M34.45875 4.075312500000001a5.210625 5.210625 0 0 0 -3.031875 -1.09875A226.44 226.44 0 0 0 22.5 2.8125c-6.90375 0 -11.732812500000001 0.2596875 -14.7590625 0.5053125 -2.3953125 0.19499999999999998 -4.2281249999999995 2.0278125 -4.423125 4.423125C3.0721875 10.767187499999999 2.8125 15.59625 2.8125 22.5c0 6.90375 0.2596875 11.732812500000001 0.5053125 14.7590625 0.19499999999999998 2.3953125 2.0278125 4.2281249999999995 4.423125 4.423125C10.767187499999999 41.9278125 15.59625 42.1875 22.5 42.1875c6.90375 0 11.732812500000001 -0.2596875 14.7590625 -0.5053125 2.3953125 -0.19499999999999998 4.2281249999999995 -2.0278125 4.423125 -4.423125C41.9278125 34.2328125 42.1875 29.403750000000002 42.1875 22.5c0 -3.4959375 -0.0665625 -6.459375 -0.1640625 -8.926875a5.210625 5.210625 0 0 0 -1.0996875 -3.0328125c-0.80625 -1.021875 -1.86375 -2.2753125 -3.0271875 -3.4378124999999997 -1.1625 -1.1625 -2.4168749999999997 -2.2199999999999998 -3.4378124999999997 -3.0271875Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.33625 2.90625c0.031875 0.6609375 0.0525 1.4475 0.0525 2.368125 0 0.9918750000000001 -0.024374999999999997 1.828125 -0.06 2.5190625 -0.08249999999999999 1.588125 -1.32375 2.754375 -2.9128125000000002 2.821875 -0.9965624999999999 0.041249999999999995 -2.2931250000000003 0.073125 -3.9178125 0.073125 -1.62375 0 -2.9203125 -0.031875 -3.916875 -0.0740625 -1.5890625 -0.065625 -2.8303125000000002 -1.2328124999999999 -2.9128125000000002 -2.8209375a48.668437499999996 48.668437499999996 0 0 1 -0.060937500000000006 -2.5190625c0 -0.920625 0.0215625 -1.7071874999999999 0.0534375 -2.368125",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M34.0875 41.896874999999994c0.1190625 -1.8871875 0.223125 -4.5478125 0.223125 -8.0765625 0 -4.190625 -0.14625 -7.1578124999999995 -0.290625 -9.058125 -0.12 -1.5975 -1.3359375 -2.8246875 -2.9325 -2.953125 -1.828125 -0.14625 -4.6434375 -0.2934375 -8.589375 -0.2934375 -3.9450000000000003 0 -6.7612499999999995 0.1471875 -8.5884375 0.294375 -1.5975 0.1275 -2.8125 1.3546875 -2.9334375 2.953125 -0.1434375 1.8993749999999998 -0.290625 4.8665625 -0.290625 9.0571875 0 3.5287499999999996 0.1040625 6.189375 0.223125 8.0765625",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 924",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.8125 29.0625h9.375",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 925",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.8125 34.6875h5.625",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDisk);
export default __webpack_public_path__ + "static/media/floppy-disk.cd2f7de63ff285642fc261272226443c.svg";
export { ForwardRef as ReactComponent };